import React from 'react'

const Divider = ({
  className = "flex items-center justify-center my-4",
  borderStyle = "border-[#D1D1D1]",
  textStyle = "text-xs text-[#6D6D6D]",
  text = "",
}) => {
  return (
    <React.Fragment>
      <div className={className}>
        <div className={`flex-grow border-t ${borderStyle}`}></div>
        {text && <span className={`px-4 ${textStyle}`}>{text}</span>}
        <div className={`flex-grow border-t ${borderStyle}`}></div>
      </div>
    </React.Fragment>
  );
};

export default Divider